

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { REGULATION_ROLE } from '@/class/const'
import { RoleId } from '@/enum'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import HeadlineDot from '@/components/Utils/headline/HeadlineDot.vue'

@Component({
  components: {
    BtnSquare,
    HeadlineDot
  }
})
export default class RandomUseRoleSettings extends Vue {
  @Prop() room!: Room;
  randomUseRoles: RoleId[] = [];

  created () {
    this.randomUseRoles = this.room.settings.randomUseRoles
  }

  get regulationRole () {
    return REGULATION_ROLE
  }

  pushRoles (roleId: RoleId) {
    this.randomUseRoles.push(roleId)
    this.room.setRandomUseRoles(this.randomUseRoles)
  }

  removeRandomUseRoles (index: number) {
    this.randomUseRoles.splice(index, 1)
    this.room.setRandomUseRoles(this.randomUseRoles)
  }
}
